module.exports = __webpack_public_path__ + "img/q.31ff0f7b.jpg";